<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics

========================================================================================== -->

<template>
  <div id="course-page">
    <vs-alert :active.sync="errorOccurred" color="danger" title="Course Not Found">
      <span>Course record with id: {{ $route.params.courseId }} not found. </span>
      <span> <span>Check </span><router-link :to="{ name: 'courses' }"
                                             class="text-inherit underline">Course Selector</router-link> </span>
    </vs-alert>

    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <div
            class="vx-card rounded-lg flex w-full p-4"
        >
          <div class="flex justify-between w-full">
            <div class="flex flex-wrap content-center pl-6 pr-6">
              <h1 class="mb-2 font-light text-white w-full" style="font-size: 3rem" v-if="courseData">{{
                  courseData.name
                }}</h1>
              <h2 class="mb-2 text-white w-full" v-if="courseData">
                Mass Course Report
              </h2>
            </div>
            <img
                :src="
                courseData.thumbnail !== null
                  ? courseData.thumbnail
                  : 'https://cdn.discordapp.com/attachments/746242308084858900/848762736255172679/default-placeholder.png'
              "
                class="rounded hidden lg:block"
                style="max-width: 150px; max-height: 150px; width: 20%"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="vx-row" v-if="!courseCompletionData">
      <div class="vx-col w-full">
        <vx-card>
          <h4 class="font-light mb-2">Enter Emails To Generate Report</h4>
          <vs-textarea height="500px" v-model="massEmails" class="mb-4"/>
          <vs-button type="gradient" @click="generateReport()">Generate Report</vs-button>

        </vx-card>

      </div>
    </div>

    <div class="vx-row" v-if="courseCompletionData">
      <div class="vx-col w-full">
        <vs-table :data="courseCompletionData" max-items="10" search class="" pagination>
          <template slot="header">
            <h3 class="ml-4">Generated Report</h3>
          </template>

          <template slot="thead">
            <vs-th>Student</vs-th>
            <vs-th>Email</vs-th>
            <vs-th>Simulation</vs-th>
            <vs-th>FlashCard</vs-th>
            <vs-th>ExamEdge Attempts</vs-th>
            <vs-th>ExamEdge Assignments</vs-th>
            <vs-th>ExamEdge Average Score</vs-th>
            <vs-th>Compliant</vs-th>
            <vs-th>View More Details</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr v-for="attach in data" :key="attach.id">

              <vs-td :data="attach.user">
                {{ attach.user.first_name }} {{ attach.user.last_name }}
              </vs-td>

              <vs-td :data="attach.user.email">
                {{ attach.user.email }}
              </vs-td>

              <vs-td :data="attach.simulation">
                {{ attach.simulation.simulations_percent }}% ({{
                  attach.simulation.simulations_completed
                }}/{{ attach.simulation.simulations_total }})
              </vs-td>

              <vs-td :data="attach.flashcard">
                {{ attach.flashcard.sets_percent }}% ({{
                  attach.flashcard.sets_completed
                }}/{{ attach.flashcard.sets_total }})
              </vs-td>

              <vs-td :data="attach.examedge">
                {{ attach.examedge.attempts_total }} Total - {{ attach.examedge.attempts_study_mode }} Study -
                {{ attach.examedge.attempts_test_mode }} Test
              </vs-td>

              <vs-td :data="attach.examedge">
                {{ attach.examedge.assignments_completed }}/{{ attach.examedge.assignments_total }}
              </vs-td>

              <vs-td :data="attach.examedge">
                {{ attach.examedge.assignments_percent }}%
              </vs-td>

              <vs-td :data="attach.compliant">
                <feather-icon v-if="attach.examedge.assignments_completed === attach.examedge.assignments_total" icon="CheckCircleIcon" svgClasses="h-6 w-6 text-success"/>
                <feather-icon v-else icon="XCircleIcon" svgClasses="h-6 w-6 text-danger"/>
              </vs-td>

              <vs-td :data="attach.examedge">
                <vs-button color="success" size="small" type="border" icon-pack="feather" icon="icon-file-text"
                           class="w-full"
                           @click="openProgress(attach.user.id)">
                  View Details
                </vs-button>
              </vs-td>


            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>

  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import LottieAnimation from '../../../../../components/lottie/LottieAnimation'

export default {
  data () {
    return {
      courseData: null,
      errorOccurred: false,

      massEmails: '',
      courseCompletionData: null
    }
  },
  components: {
    VueApexCharts,
    LottieAnimation
  },
  computed: {
    activeCourseInfo () {
      return this.$store.state.AppActiveCourse
    },
    skeletonColor () {
      const theme = this.$store.state.theme
      if (theme === 'light') return 'rgb(224, 224, 224)'
      if (theme === 'dusk') return 'rgb(5, 0, 53, 1)'
      if (theme === 'dark') return 'rgb(22, 23, 25)'
    },
    skeletonHighlight () {
      const theme = this.$store.state.theme
      if (theme === 'light') return 'rgb(248, 248, 248)'
      if (theme === 'dusk') return 'rgb(27 25 53)'
      if (theme === 'dark') return 'rgb(94 94 94 / 73%)'
    }
  },
  methods: {
    loadCourseInfo (id) {
      this.$http
          .get(`courses/${id}`)
          .then((response) => {
            if (response.data.data) {
              this.courseData = response.data.data
            }
          })
          .catch(() => {
          })
    },
    openProgress(uid){
      window.open(`/a/users/${uid}/progress/${this.courseData.id}`, '_blank')
    },
    generateReport () {
      this.$vs.loading()
      console.log('GENERATING REPOTR')
      const emailsArray = this.massEmails.split('\n').filter(email => email.trim() !== '')

      this.$http
          .post(`courses/${this.courseData.id}/mass`, {emails: emailsArray})
          .then((response) => {
            if (response.data.data) {
              this.$vs.loading.close()
              this.courseCompletionData = response.data.data
              console.log(response.data.data)
            }
          })
          .catch(() => {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Report Could Not Be Generated',
              text: 'Please email cameron@intellectualpoint.com for more information.',
              color: 'danger',
              position: 'top-right'
            })

          })
    }
  },
  mounted () {
    console.log(this.$route.params.courseId)
  },
  beforeMount () {
    this.loadCourseInfo(this.$route.params.courseId)
  },
  watch: {}
}
</script>
